// Фон под артом героя: его цвет `#RRGGBB` с прозрачностью (слева арт прозрачный).
// Нет цвета — фон карточки.
export const heroTint = (color: string | null): string | undefined =>
  color === null ? undefined : `${color}30`;
